
import React, { Component } from 'react'
import styled from 'styled-components'
import ReactDOM from 'react-dom';

import ChevronDown from '../../../images/chevron_select.svg'
import ChevronUp from '../../../images/chevron_select_up.svg'

const Wrapper = styled.div`
    width: 100%;

    > button {
        width: 100%;
        height: 39px;
        border: none;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        margin: 0px;
        padding: 12px 15px 11px 15px;
        background: #FFFFFF;
        border-bottom: 1px solid #CCCCCC;
        font-family: Lato-Regular;
        font-size: 12px;
        text-transform: uppercase;
        text-align: left;
        color: #666666;
        line-height: 16px;

        background-image: url(${ChevronUp});
        background-repeat: no-repeat;
        background-position-x: -moz-calc(100% - 15px);
        background-position-x: -webkit-calc(100% - 15px);
        background-position-x: -o-calc(100% - 15px);
        background-position-x: calc(100% - 15px);
        background-position-y: center;
        background-size: 18px 11px;

        cursor: pointer;
    }

    > button[aria-expanded=false] {
        background-image: url(${ChevronDown});
    }
`

const Values = styled.div`

    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;

    // Mobile version.
    @media (max-width: 768px) {
        background-color: #EDEDED;
    }

    > table {
        margin: 0px auto;
        font-family: Lato-Regular;
        font-size: 12px;
        text-align: left;
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
        display: table;
    }

    > table, th, td {
        border: 1px solid rgb(0, 0, 0);
    }

`

class ComparisonCategory extends Component {
    componentDidMount() {
        const domNode = ReactDOM.findDOMNode(this);
        var h2 = domNode.querySelectorAll('button[aria-expanded][aria-controls]');
        var be = new window.ButtonExpand(h2[0]);
        be.init();
    }

    render() {
      const ValueHeader = ({title, brokers}) => (
                <tr>
                    <th dangerouslySetInnerHTML={{__html: title}}/>
                    {brokers.map((broker, index) => (
                        <th scope="col" style={{backgroundColor: broker.broker_branding_color, color: "#FFFFFF"}} dangerouslySetInnerHTML={{__html: "<p>" + broker.name + "</p>"}}/>
                    ))}
                </tr>
        )

      const Value = ({title, values}) => (
              <tr className="info">
                  <th scope="row" className="value0" dangerouslySetInnerHTML={{__html: title}}/>
                  {values.map((value, index) => (
                    <td dangerouslySetInnerHTML={{__html: value}}/>
                  ))}
              </tr>
      )

      const { category, index, brokers } = this.props;

      return (
        <Wrapper>
          <button tabIndex={0} aria-expanded="true" aria-controls={`comparison_category_${index}`}>{category.title}</button> 
          <div id={`comparison_category_${index}`}>
          <Values>
            <table>
                <thead>
                    <ValueHeader key={index} title={category.title} brokers={brokers}/>
                </thead>
                <tbody>
                    {category.vars.map((variable, index) => (
                        <Value key={index} title={variable.name} values={variable.values}/>
                    ))}
                </tbody>
            </table>
          </Values>
          </div>
        </Wrapper>
      )
    }
}

export default ComparisonCategory;
